import { apiFetch, apiAction } from 'utils';
import * as constants from '../constants/index';

export default (relation, contactIds, schoolYearId, combineFamilyContacts) =>
  apiAction(constants.BEGIN_GETTING_RELATED, constants.SUCCESS_GETTING_RELATED, constants.ERROR_GETTING_RELATED,
    (state) =>
      apiFetch.post(
        state,
        `related_contacts`,
        {
          relation: relation,
          contact_ids: contactIds,
          school_year_id: schoolYearId,
          combine_family_contacts: combineFamilyContacts
        }
      ),
    {}
  );
